(function () {
  'use strict';
  if (window.roccoKachingPriceSync) return;
  window.roccoKachingPriceSync = true;

  var states = new WeakMap();

  function ensureStyles() {
    if (document.getElementById('rocco-bundle-price-styles')) return;
    var style = document.createElement('style');
    style.id = 'rocco-bundle-price-styles';
    style.textContent = [
      '[data-rocco-bundle-price] .price--on-sale .rocco-price-sale-row{display:flex;align-items:center;flex-wrap:wrap;column-gap:1rem;row-gap:.6rem}',
      '[data-rocco-bundle-price] .price--on-sale .price__badge-sale{display:none}',
      '[data-rocco-bundle-price] .rocco-price-sale-row .price-item{margin-right:0}',
      '[data-rocco-bundle-price] .rocco-price-current{order:1}',
      '[data-rocco-bundle-price] .rocco-price-compare{order:2}',
      '[data-rocco-bundle-price] .rocco-price-saving{order:3;position:relative;display:inline-block;margin-left:6px;padding:2px 6px;border-radius:2px;background:#aeb78e;color:#000;font-size:1.4rem;font-weight:500;line-height:1.5;white-space:nowrap}',
      '[data-rocco-bundle-price] .rocco-price-saving::before{content:"";position:absolute;left:-6px;top:50%;transform:translateY(-50%);width:7px;height:14px;background:inherit;clip-path:polygon(100% 0,0 50%,100% 100%);pointer-events:none}',
      '[data-rocco-bundle-price] .rocco-price-unit-row{display:flex;align-items:baseline;flex-wrap:wrap;column-gap:1rem;row-gap:.2rem;margin-top:.2rem}',
      '[data-rocco-bundle-price] .rocco-price-unit-row[hidden]{display:none!important}',
      '[data-rocco-bundle-price] .rocco-price-unit-row>.unit-price{margin:0}',
      '[data-rocco-bundle-price] .rocco-price-per-piece{font-size:1.3rem;font-weight:500;line-height:1.5;color:rgba(var(--color-foreground),.7)}',
      '[data-rocco-bundle-price] .rocco-price-per-piece[hidden]{display:none!important}',
      '@media screen and (max-width:749px){[data-rocco-bundle-price] .price__regular > .price-item--regular,[data-rocco-bundle-price] .price__sale > .price-item--sale{font-size:2.2rem}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function updateSaving(price, widget, current, full) {
    var row = price.querySelector('.price__sale');
    if (!row) return;
    row.classList.add('rocco-price-sale-row');
    var sale = row.querySelector('.price-item--sale');
    var compare = row.querySelector('s.price-item--regular');
    if (sale) sale.classList.add('rocco-price-current');
    if (compare && compare.parentElement !== row) compare.parentElement.classList.add('rocco-price-compare');
    var saving = row.querySelector('[data-rocco-saving]');
    if (!saving) {
      saving = document.createElement('span');
      saving.className = 'rocco-price-saving';
      saving.setAttribute('data-rocco-saving', '');
      row.appendChild(saving);
    }
    var cents = Math.max(0, Math.round(full.amount * 100) - Math.round(current.amount * 100));
    saving.dataset.roccoSavingCents = String(cents);
    saving.classList.toggle('hidden', cents <= 0);
    if (cents <= 0) {
      setText(saving, '');
      return;
    }
    var locale = document.documentElement.lang || 'de';
    var language = locale.toLowerCase().split('-')[0];
    var labels = { de: 'Du sparst ', it: 'Risparmi ', en: 'You save ' };
    var currency = widget.config && widget.config.marketCurrencyCode || 'EUR';
    var amount;
    try {
      amount = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (_) {
      amount = (cents / 100).toFixed(2) + ' ' + currency;
    }
    setText(saving, (labels[language] || labels.en) + amount);
  }

  function setText(element, text) {
    if (element && element.textContent !== text) element.textContent = text;
  }

  function selectedBar(widget) {
    return Array.from(widget.querySelectorAll('.kaching-bundles__bar--selected')).find(function (bar) {
      return !bar.closest('.kaching-bundles__subscriptions');
    });
  }

  function updatePiecePrice(price, widget, bar, current, money) {
    var unit = price.querySelector('.unit-price');
    var row = price.querySelector('[data-rocco-price-unit-row]');
    if (!row) {
      row = document.createElement('div');
      row.className = 'rocco-price-unit-row';
      row.setAttribute('data-rocco-price-unit-row', '');
      if (unit) {
        unit.insertAdjacentElement('beforebegin', row);
        row.appendChild(unit);
      } else {
        (price.querySelector('.price__container') || price).appendChild(row);
      }
    }
    var piece = row.querySelector('[data-rocco-piece-price]');
    if (!piece) {
      piece = document.createElement('span');
      piece.className = 'rocco-price-per-piece';
      piece.setAttribute('data-rocco-piece-price', '');
      row.prepend(piece);
    }
    if (row.firstElementChild !== piece) row.prepend(piece);
    var dealBlock = widget.dealBlock;
    var deal = dealBlock && (dealBlock.dealBars || []).find(function (item) { return item.id === bar.dataset.dealBarId; });
    var quantity = deal && Number(deal.quantity);
    if (deal && deal.quantitySelector) quantity = Number(widget.quantity) || quantity;
    var hasPiece = deal && (!deal.dealBarType || deal.dealBarType === 'quantity-break') && Number.isFinite(quantity) && quantity > 0;
    var label = '';
    if (hasPiece) {
      var total = bar.querySelector('.kaching-bundles__bar-pricing .kaching-bundles__bar-price');
      var raw = total ? total.textContent.replace(/[^0-9.,]/g, '') : '';
      var index = Math.max(raw.lastIndexOf(','), raw.lastIndexOf('.'));
      var decimals = raw.length - index - 1;
      var amount = raw ? Number(index >= 0 && decimals > 0 && decimals <= 2 ? raw.slice(0, index).replace(/[.,]/g, '') + '.' + raw.slice(index + 1) : raw.replace(/[.,]/g, '')) : NaN;
      var perPiece = dealBlock.showPricesPerItem ? amount : amount / quantity;
      hasPiece = Number.isFinite(perPiece);
      if (hasPiece) {
        var locale = document.documentElement.lang || 'de';
        var language = locale.toLowerCase().split('-')[0];
        var labels = { de: ['Ab ', ' pro Stück'], it: ['Da ', ' al pezzo'], en: ['From ', ' per piece'] };
        var copy = labels[language] || labels.en;
        var rounded = Math.round((perPiece + Number.EPSILON) * 100) / 100;
        var formattedNumber = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rounded);
        // Preserve the store's currency position, but localize the numeric amount.
        var formatted = money(current).replace(/\d[\d.,\s\u00a0\u202f]*\d|\d/, formattedNumber);
        label = copy[0] + formatted + copy[1];
        piece.dataset.roccoPieceAmount = String(rounded);
      }
    }
    setText(piece, label);
    if (piece.hidden !== !hasPiece) piece.hidden = !hasPiece;
    var hideRow = !hasPiece && (!unit || unit.classList.contains('hidden'));
    if (row.hidden !== hideRow) row.hidden = hideRow;
  }

  function update(state) {
    var widget = state.widget;
    if (!widget.isConnected || typeof widget.pricing !== 'function') return;
    var wrapper = document.getElementById('price-' + state.scope.dataset.section);
    if (!wrapper || !state.scope.contains(wrapper)) return;
    var price = wrapper.querySelector('.price');
    if (!price) return;
    ensureStyles();

    // Dawn replaces this markup when the product variant changes.
    if (state.price !== price) {
      state.price = price;
      state.originalMarkup = wrapper.innerHTML;
      state.active = false;
    }

    var bar = selectedBar(widget);
    if (!widget.selectedDealBarId || !bar) {
      if (state.active) {
        wrapper.innerHTML = state.originalMarkup;
        delete wrapper.dataset.roccoBundlePrice;
        state.active = false;
      }
      return;
    }

    var pricing;
    try {
      pricing = widget.pricing();
    } catch (_) {
      return; // The custom element may still be initializing.
    }
    if (!pricing || !pricing.discountedPrice || !pricing.fullPrice) return;
    var current = pricing.discountedPrice;
    var full = pricing.fullPrice;
    if (!Number.isFinite(current.amount) || !Number.isFinite(full.amount) || !current.formatted) return;

    function money(value) {
      // Use Kaching's localized currency strings; do not recalculate its discounts.
      var template = document.createElement('template');
      template.innerHTML = value.formatted;
      return template.content.textContent.replace(/\s*EUR\b/g, '').trim();
    }

    var onSale = full.amount > current.amount + 0.00001;
    setText(price.querySelector('.price__regular .price-item--regular'), money(current));
    setText(price.querySelector('.price__sale .price-item--sale'), money(current));
    setText(price.querySelector('.price__sale s.price-item--regular'), onSale ? money(full) : '');
    price.classList.toggle('price--on-sale', onSale);
    if (onSale) price.classList.remove('price--no-compare');
    updateSaving(price, widget, current, full);

    var unit = price.querySelector('.unit-price');
    if (unit) {
      // The bundle supplies its own unit price. Mixed-product bundles have none.
      var bundleUnit = bar.querySelector('.kaching-bundles__bar-unit-price:not(.rocco-kaching-piece-price)');
      var unitText = bundleUnit ? bundleUnit.textContent.replace(/\s+/g, ' ').trim().replace(/\s*\/\s*/, '/') : '';
      unit.classList.toggle('hidden', !unitText);
      if (unitText) setText(unit.querySelector('.price-item'), unitText);
    }
    updatePiecePrice(price, widget, bar, current, money);
    wrapper.dataset.roccoBundlePrice = widget.selectedDealBarId;
    state.active = true;
  }

  function schedule(widget) {
    var state = states.get(widget);
    if (!state) {
      var scope = widget.closest('product-info');
      if (!scope || !scope.dataset.section || widget.closest('kaching-bundles-sticky-atc')) return;
      state = { widget: widget, scope: scope, queued: false };
      states.set(widget, state);
      var observedState = state;
      new MutationObserver(function (records) {
        // Reapply after Dawn asynchronously refreshes the native price.
        if (records.some(function (record) {
          var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (target && target.closest('[id="price-' + scope.dataset.section + '"]')) return true;
          return Array.from(record.addedNodes).some(function (node) {
            return node.nodeType === 1 && (node.id === 'price-' + scope.dataset.section || node.querySelector('[id="price-' + scope.dataset.section + '"]'));
          });
        })) schedule(observedState.widget);
      }).observe(scope, { childList: true, subtree: true, characterData: true });
    }
    if (state.queued) return;
    state.queued = true;
    requestAnimationFrame(function () {
      state.queued = false;
      update(state);
    });
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('kaching-bundles-block')) schedule(root);
    root.querySelectorAll('kaching-bundles-block').forEach(schedule);
  }

  ['variants-changed', 'deal-bar-selected', 'kaching-bundles-block-hydrated'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (event.target.matches && event.target.matches('kaching-bundles-block')) schedule(event.target);
    }, true);
  });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  new MutationObserver(function (records) {
    records.forEach(function (record) { record.addedNodes.forEach(scan); });
  }).observe(document, { childList: true, subtree: true });
  scan(document);
})();
